/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-03 10:27:50
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-25 18:16:06
 */

/**
 * 删除后端传过来的多余的数据
 * "created_by": "",
 *"created_utc_datetime":
 *"updated_by": "",
 *"updated_utc_datetime"
 *
 */
import { findSrc } from "@/service/api/upload.js"
import store from "@/store"
import http from "@/service/httpConfig.js"
import axios from "axios"
import azureUpload from "vue-azure-blob-upload"
import JSZip from "jszip"
import FileSaver from "file-saver"
import ls from "@/utils/Ls"
import AWSS3 from "@/utils/awss3" //AWS S3
import { get_list } from "@/service/api/func_module"
import { upload_static_File } from "@/service/api/staticResourceUpload.js"
import { addFile, addResultFile, deleteFile, deleteResultFile } from "@/service/api/fileManagements.js"
import moment from "moment"
import Message from "@/components/Message/index"
import i18n from "@/lang"

const $deletefield = function (arr, obj) {
  //传对象  数组要传null $deletefield(null,obj)
  if (arr) {
    if (arr.length > 0) {
      return arr.map((item) => {
        delete item.created_by
        // delete item.created_utc_datetime//2021-01-18 推送消息日志开放
        delete item.updated_by
        delete item.updated_utc_datetime
        return item
      })
    } else {
      return []
    }
  }
  if (Object.keys(obj).length > 0) {
    delete obj["created_by"]
    // delete obj["created_utc_datetime"];//2021-01-18 推送消息日志开放
    delete obj["updated_by"]
    delete obj["updated_utc_datetime"]
    return obj
  } else {
    return {}
  }
}

//格式化日期
const $moment = (val, val2 = "YYYY-MM-DD") => {
  return moment(val).format(val2)
}

const getProductUuid = async () => {
  //获取ProductUuid
  const res = await get_list()
  if (res.code == 200) {
    store.commit("set_product_uuid", res.data[0].uuid)
  }
}
// '?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2024-03-31T18:28:05Z&st=2020-09-24T10:28:05Z&spr=https,http&sig=UhRGJea8z8lKd1VG1rmtknnabe5Fa27gEstPytfVo5M%3D'
function azureUploadFn(url, f, uuid, sasToken) {
  return new Promise((resolve, reject) => {
    AWSS3.upload(f, url)
      .then((data) => {
        addResultFile({
          uuid: uuid,
          result: 1,
        })
        resolve({
          code: "200",
          msg: i18n.t("message_file_upload_successfully"),
          uuid: uuid,
          url: data.url,
          sasToken,
        })
      })
      .catch((error) => {
        console.log(error)
        addResultFile({
          uuid: uuid,
          result: 2,
        })
        reject({
          code: "403",
          msg: i18n.t("message_file_upload_failed"),
          uuid: uuid,
          sasToken,
        })
      })
    // azureUpload(
    //   console.log.bind(console),
    //   axios.create()
    // )({
    //   baseUrl: url,
    //   sasToken,
    //   file: f,
    //   progress: (progress) => { },
    //   complete: (res) => {
    //     addResultFile({
    //       uuid: uuid,
    //       result: 1,
    //     });
    //     resolve({
    //       code: "200",
    //       msg: i18n.t("message_file_upload_successfully"),
    //       uuid: uuid,
    //       url: url + sasToken,
    //       sasToken,
    //     });
    //   },
    //   error: (error) => {
    //     addResultFile({
    //       uuid: uuid,
    //       result: 2,
    //     });
    //     reject({
    //       code: "403",
    //       msg: i18n.t("message_file_upload_failed"),
    //       uuid: uuid,
    //       sasToken,
    //     });
    //   },
    //   blockSize: f.size,
    // });
  })
}
//上传单个文件 本地上传和微软云上传
const $uploadFiles = async (file, options = {}) => {
  if (!file || file.length <= 0) return
  let f = file[0]
  // if (!store.state.product_uuid) {
  //   await getProductUuid()
  // }
  try {
    let upload_type = store.state.sys_upload_type
    if (upload_type["file_upload_method"] == "local") {
      let formData = new FormData()
      formData.append("attachment_file", f)

      const upload_plan = await addFile({
        ...options,
        module_uuid: store.state.menuFunctionUuid,
        function_uuid: store.state.menuFunctionUuid,
        attachment_data_field: "thumbnail_img",
        attachment_title: f.name,
        attachment_size: f.size,
        org_level_uuid: store.state.currentCompany,
        is_static_resource: options.resource_key ? 1 : 0,
        client_uuid: store.state.userData.clientUuid,
        token: ls.get("token"),
      })
      // upload_plan.data["upload_url"] =
      //   "https://debugbaseserver.kaifa000.com/mrcbase/api/fileManager/upload-file/v1";
      formData.append("formData", JSON.stringify(upload_plan.data))

      const upload_res = await http.uploadFile(
        upload_plan.data["upload_url"],
        formData,
        // {
        //   baseURL: upload_plan["upload_url"],
        // }
      )
      // const upload_res = {
      //   code: 200,
      //   data: {
      //     attachment_file: "qwer.png",
      //     attachment_title: "qwer.png",
      //     upload_url:
      //       "https://debugbaseserver.kaifa000.com/mrcbase/api/fileManager/upload-file/v1",
      //     uuid: "62701b14-3771-49cb-90c5-36540d2da75f",
      //     attachment_url: "staticResource",
      //   },
      // };
      if (upload_res.code == 200) {
        //上传成功
        await addResultFile({
          uuid: upload_res.data.uuid,
          result: 1,
        })
      }

      const upload_url_res = await findSrc({
        uuid: upload_res.data.uuid,
      })
      // var blob = new Blob([upload_url_res]);
      // var url = window.URL.createObjectURL(blob);
      if (upload_res.code == 200) {
        return {
          code: "200",
          msg: i18n.t("message_file_upload_successfully"),
          name: upload_url_res.data.files[0].name,
          uuid: upload_url_res.data.files[0].uuid,
          url: upload_url_res.data.files[0].path,
          size: upload_url_res.data.files[0].size,
          file_name: upload_url_res.data.files[0].file_name,
          sasToken: "",
        }
      } else {
        return {
          code: "403",
          msg: i18n.t("message_file_upload_failed"),
          uuid: uuid,
          sasToken: "",
        }
      }
    } else {
      const resp = await addFile({
        ...options,
        function_uuid: store.state.menuFunctionUuid,
        // product_uuid: store.state.product_uuid,
        attachment_title: f.name,
        attachment_size: f.size,
      })
      if (resp.code == 200) {
        //后端未返回剩余空间大小
        let res = resp.data
        let arr = res.upload_url.split("?")
        let url = arr[0]
        let sasToken = "?" + arr[1]

        return azureUploadFn(url, f, res.uuid, sasToken)
          .then((res) => {
            return res
          })
          .catch((err) => {
            return err
          })
      } else {
        return {
          code: "403",
          msg: i18n.t("message_failed_to_obtain_new_preparation_file"),
        }
      }
    }
  } catch (err) {
    return err
  }
}

const $deleteFile = async (uuid, sas) => {
  //删除微软云上的上传文件
  // console.log(path);
  let upload_type = store.state.sys_upload_type
  if (upload_type["file_upload_method"] == "local" || !uuid) {
    return ""
  } else {
    // if (path == "" || path == undefined) return;
    // const res = await findSrc({ uuid: "" });
    // let sasToken = res.data.sastoken;
    // let index = path.indexOf("?");
    // let a = path.slice(0, index).split("/");
    // let blobSasUrl = a.slice(0, a.length - 2).join("/") + sasToken;
    // const blobServiceClient = new BlobServiceClient(blobSasUrl);
    // const containerName = a[a.length - 2];
    // const filename = a[a.length - 1];
    // const containerClient = blobServiceClient.getContainerClient(containerName);
    // return new Promise((resolve, reject) => {
    //   containerClient
    //     .deleteBlob(filename)
    //     .then((res) => {
    //       resolve(res);
    //     })
    //     .catch((err) => {
    //       reject(err);
    //     });
    // });
    return deleteFile({
      uuid: uuid,
    })
  }
}

//上传多个文件
const $uploadFilesMore = async (file, options) => {
  // console.log(file, file.length);
  if (!file || file.length <= 0) return
  if (!store.state.product_uuid) {
    await getProductUuid()
  }
  // let allSize = 0
  // file.forEach(item => {
  //   allSize += item.size
  // })
  file.forEach(async (item) => {
    let res = await addFile({
      ...options,
      function_uuid: store.state.menuFunctionUuid,
      product_uuid: store.state.product_uuid,
      attachment_title: item.name,
      attachment_size: item.size,
    })
    if (res.code == 200) {
      res = res.data
    } else {
      return Message({ text: i18n.t(res.msg) })
    }
    let url = res.attachment_domain + "/" + res.attachment_container + "/" + res.module_uuid + "/" + res.attachment_title
    // let url = 'https://mrcbase.blob.core.windows.net/testexcel/' + item.size
    // console.log(url + res.sostoken, "url----");
    const res2 = await azureUploadFn(url, item, res.uuid, res.sostoken)
    return res2
  })
}
const urlarr = [
  // 'https://mrcbase.blob.core.windows.net/mrc-template/成本中心模板.xlsx',
  // 'https://mrcbase.blob.core.windows.net/b9bcfe3f-42bd-449d-bcad-c5b4f2b63e9e/public-module/4a566af2-a639-4868-803a-07f8d624bced.jpg?sv=2019-12-12&ss=bfqt&srt=sco&st=2021-03-08T05%3A45%3A49Z&se=2021-03-08T05%3A50%3A49Z&sp=rd&sig=F7PTfszb4Rg5ku57xGa5boP9vSBEFr%2BCG7pB0Gu2XZY%3D',
  // 'https://mrcbase.blob.core.windows.net/mrc-template/岗位等级模板.xls',
  // 'https://mrcbase.blob.core.windows.net/mrc-template/岗位模板.xls'
]

const downloadIamge = (imgSrc, name, type) => {
  var image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous")
  image.onload = function () {
    var canvas = document.createElement("canvas")
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext("2d")
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL("image/" + type) //得到图片的base64编码数据
    var a = document.createElement("a") // 生成一个a元素
    var event = new MouseEvent("click") // 创建一个单击事件
    a.download = name || "photo" // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = imgSrc
}
// /**
// * @param src 文件地址
// * @param name 文件名称
// */
// const downloadFile = (src, name) => {
//   let x = new XMLHttpRequest();
//   x.open("GET", src, true);
//   x.responseType = 'blob';
//   x.onload = function (e) {
//     let url = window.URL.createObjectURL(x.response)
//     let a = document.createElement('a');
//     a.href = url
//     a.download = name
//     a.click()
//   }
//   x.send();
// }
/*
 *单个文件下载
 *uuid   文件uuid
 *name  文件名称
 *type 文件类型
 */
const $singleDownload = async (uuid, name, type) => {
  findSrc({
    uuid: uuid,
  }).then((res) => {
    let arr = ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tiff"]
    if (arr.indexOf(type.toLowerCase()) !== -1) {
      //图片
      downloadIamge(res.data.files[0].path, name, type)
    } else {
      let a = document.createElement("a")
      a.href = res.data.files[0].path
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  })
}
/*
 *批量下载文件所用函数
 */
const downImg = (zip) => {
  zip
    .generateAsync({
      type: "blob",
    })
    .then((content) => {
      console.log(content, "下载时间")
      let fileName = "批量下载.zip"
      FileSaver.saveAs(content, fileName)
    })
  // return new Promise((resolve, reject) => {
  //   zip
  //     .generateAsync({
  //       type: "blob"
  //     })
  //     .then(content => {
  //       let fileName = "批量下载.zip";
  //       FileSaver.saveAs(content, fileName);
  //       resolve({ code: 200 })
  //     }).catch(error => {
  //       reject("文件压缩失败" + error);
  //     })
  // })
}
const getFile = (url) => {
  return new Promise((resolve, reject) => {
    // 这里的$http是Vue里的axios
    axios({
      method: "get",
      url,
      responseType: "arraybuffer",
    })
      .then((data) => {
        resolve(data.data)
      })
      .catch((error) => {
        reject("PDF加载失败：" + error)
      })
  })
}

/*
 *批量下载文件
 *arr   文件内容，地址，名称等等组成的数组对象
 *url   文件地址key 默认为path
 *name  文件名称key 默认为file_name
 */
const $batchDownload = async (arr, url = "path", name = "file_name") => {
  return new Promise(async (resolve, reject) => {
    try {
      let zip = new JSZip()
      let fns = [] //Promise对象集合
      arr.forEach((item, index) => {
        let Index = item[name].lastIndexOf(".") //判断最后一个·位置
        var newStr = item[name].slice(0, Index) + "(" + index + ")" + item[name].slice(Index) //防止相同名字的文件被覆盖
        fns.push(
          new Promise((resolve, reject) => {
            getFile(item[url])
              .then((res) => {
                zip.file(newStr, res, {
                  binary: true,
                })
                resolve()
              })
              .catch((err) => {
                reject()
              })
          }),
        )
      })
      Promise.all(fns)
        .then((result) => {
          downImg(zip)
          resolve({ code: 200, msg: "压缩文件成功" })
        })
        .catch((err) => {
          console.log(err, "压缩文件失败")
        })
    } catch (err) {
      console.log("err", err)
      reject()
    }
  })
}

export { $singleDownload, $deletefield, $moment, $uploadFiles, $uploadFilesMore, $deleteFile, $batchDownload }
